<template>
  <section>
    <!--工具条-->
    <el-col :span="4" class="toolbar">
      <el-button type="primary" size="small" @click="addFormVisible = true">新增</el-button>
    </el-col>

    <el-table :data="tableData"
              v-loading="listLoading">
               <el-table-column
        label="编号"
        prop="id"
        align="center">
      </el-table-column>
      <el-table-column
        label="分类名称"
        prop="type_name"
        align="center">
      </el-table-column>
      <el-table-column
        label="广告名称"
        prop="adver_name"
        align="center">
      </el-table-column>
      <el-table-column
        label="标识"
        prop="unique_key"
        align="center">
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        align="center">
        <template scope="scope">
          <el-button :plain="true" type="info" size="small" @click="showAdver(scope.row)">选择广告</el-button>
          <el-button :plain="true" type="info" size="small" @click="showEditForm(scope.row)">更新名称</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible">
      <el-form :model="addForm" label-width="150px" :rules="formRules" ref="addForm">
        <el-form-item label="标识" prop="unique_key">
          <el-input v-model="addForm.unique_key" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="分类名称" prop="adver_name">
          <el-input v-model="addForm.type_name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible">
      <el-form :model="editForm" label-width="150px" :rules="formRules" ref="editForm">
        <el-form-item label="标识" prop="unique_key">
          <el-input v-model="editForm.unique_key" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="分类名称" prop="type_name">
          <el-input v-model="editForm.type_name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--选择广告-->
    <el-dialog title="编辑" v-model="adverFormVisible">
      <el-row>
        <el-col :offset="2" :span="4" style="line-height: 30px;">选择广告：</el-col>
        <el-col :span="18">
          <el-select v-model="adverId" filterable placeholder="请选择" size="small" style="width: 100%;">
            <el-option
              v-for="item in adver"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="adverSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
  import config from '../../config';
  import {formatPara} from '../../static/js/util.js';

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:15,
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
        addForm: {
          type_name: '',
          unique_key: '',
          create_time: '',
          status: 0
        },
        editFormVisible: false,
        editForm: {},
        formRules: {},
        adverFormVisible: false,
        adverId: '',
        adver: [],
        id: 0
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getAdverType(this.query);
      },
      getAdverType(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/advertype/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
          } else {
            this.$message({
              message: data.msg,
              type: 'warning'
            });
          }
          this.listLoading = false;
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'warning'
          });
        })
      },
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.addForm));
              //异步请求
              this.$axios.post(config.api_url + '/advertype',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'warning'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.editForm));
              //异步请求
              this.$axios.put(config.api_url + '/advertype',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      showEditForm(row) {
        this.editFormVisible = true;
        this.editForm = row;
      },
      showAdver(row) {
        this.adverFormVisible = true;
        this.getAdver();
        this.adverId = row.adver_name + '-' + row.adver_id;
        this.id = row.id;
      },
      adverSubmit() {
        this.$axios.put(config.api_url + '/advertype/adverid', {
          id: this.id,
          adver_id: this.adverId.split('-')[1],
          adver_name: this.adverId.split('-')[0]
        }).then(response => {
          if(response.data.state) {
            this.$message({
              message: '提交成功!',
              type: 'success'
            });
            this.adverFormVisible = false;
            this.search();
          } else {
            this.$message({
              message: '关联广告失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '关联广告异常，请联系管理员',
            type: 'error'
          });
        });
      },
      getAdver() {
        this.$axios.get(config.api_url + '/adver'
        ).then(response => {
          if(response.data.state) {
            this.adver = [];
            for(const item of response.data.msg) {
              this.adver.push({
                label: item.adver_name,
                value: item.adver_name + '-' + item.adver_id
              })
            }
          } else {
            this.$message({
              message: '获取广告失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取广告异常，请联系管理员',
            type: 'error'
          });
        });
      }
    },
    created() {
      this.search();
    }
  }
</script>



// WEBPACK FOOTER //
// advertype.vue?28e8e94f